import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import ImageGallery from "./ImageGallery";
import FullBleedBackground from "./FullBleedBackground";

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(6),
  },
  content: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  intro: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(3),
    flexWrap: "wrap",
    marginBottom: theme.spacing(4),
  },
  icon: {
    fontSize: 64,
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
  ventajasTitle: {
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  ventajaBox: {
    height: "100%",
    padding: theme.spacing(3.5),
    textAlign: "center",
  },
  ventajaText: {
    fontSize: "1.05rem",
    lineHeight: 1.6,
  },
}));

const ServiceSection = ({
  id,
  icon: Icon,
  titulo,
  parrafos,
  ventajas,
  galeria,
  children,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <FullBleedBackground id={id} className={classes.content}>
        <div className={classes.intro}>
          <Icon className={classes.icon} />
          <div>
            <Typography variant="h4" component="h2" gutterBottom>
              {titulo}
            </Typography>
            {parrafos.map((parrafo, index) => (
              <Typography variant="body1" paragraph key={index}>
                {parrafo}
              </Typography>
            ))}
            {children}
          </div>
        </div>

        {ventajas && (
          <>
            <Typography variant="h5" component="h3" className={classes.ventajasTitle}>
              Ventajas y características
            </Typography>
            <Grid container spacing={2}>
              {ventajas.map((ventaja, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Paper elevation={1} className={classes.ventajaBox}>
                    <Typography variant="body1" className={classes.ventajaText}>
                      {ventaja}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </FullBleedBackground>

      {galeria && <ImageGallery items={galeria} />}
    </div>
  );
};

export default ServiceSection;
